/*
 * @Author: Teemo Ding
 * @Date: 2021-09-22 16:21:01
 * @LastEditTime: 2022-01-05 16:51:32
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/Components/ShippingRate/index.tsx
 */
import { NumberInput, RadioGroup, RadioItem } from '@/src/components/Antd';
import { Form, Input, Spin } from 'antd';
import { get } from 'lodash';
import React, { Fragment } from 'react';

import EditableTable from '@/src/components/EditableTable/EditableTable';
import { unitSuffix } from '@/src/tools/config';
import { ConditionType } from '@/src/types/common/common';
import {
  additionalDeliveryPriceColumns,
  deliveryPricesColumns,
  fixAmountColumns,
} from './config';
import styles from './css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

export enum CalculationMethod {
  UseCourier = 'UseCourier',
  Fixed = 'Fixed',
  Advanced = 'Advanced',
}
export enum CourierCalculationMethod {
  None = 'None',
  FixAmount = 'FixAmount',
  Percentage = 'Percentage',
}
interface IProps {
  value?: any[];
  onChange?: () => void;
  columns?: any[];
}
const RenderTable = ({ value, onChange, columns }: IProps) => {
  return (
    <EditableTable
      id='rateCalculationTable'
      dataSource={value}
      rowKey='currency'
      columns={columns}
    />
  );
};

export const conditionTypeList = {
  [ConditionType.Weight]: 'storeLogistics.components.weight',
  [ConditionType.Size]: 'storeLogistics.components.size',
};

const RenderCourierFee = ({ value, onChange }: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.courierFee}>
      <Input
        className={styles.input}
        size='large'
        value={value}
        suffix='%'
        onChange={onChange}
      />
      <span className={styles.courierFeeText}>
        {getI18n('storeLogistics.components.ofcouriersfeecharge')}
      </span>
    </div>
  );
};

const RenderEveryGreaterThan = ({ value, onChange, unit, min }: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.everyGreaterThan}>
      <span className={styles.everyGreaterThanText}>
        {getI18n('general.every')}
      </span>
      <NumberInput
        value={value}
        onChange={onChange}
        suffix={unitSuffix[unit]}
        size='large'
        min={min}
      />
    </div>
  );
};
const ShippingRate = ({ initCurrencyData, currenciesListLoading }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.itemBlock}>
      <div className={styles.header}>
        <div className={styles.title}>
          {getI18n('storeLogistics.components.shippingRate')}
        </div>
      </div>
      <div className={`${styles.shippingRate} ${styles.content}`}>
        <Spin spinning={currenciesListLoading}>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              get(prevValues, 'courierAccount', '') !==
              get(currentValues, 'courierAccount', '')
            }>
            {({ getFieldValue }) => {
              return (
                <Form.Item
                  label={getI18n('storeLogistics.components.rateCalculation')}
                  name={['shippingRate', 'calculationMethod']}
                  rules={[
                    {
                      required: true,
                    },
                  ]}>
                  <RadioGroup>
                    <div className={styles.radioItem}>
                      <RadioItem
                        disabled
                        // disabled={!getFieldValue('courierAccount')}
                        value={CalculationMethod.UseCourier}>
                        {getI18n(
                          'storeLogistics.components.usecouriertocalculaterate',
                        )}
                      </RadioItem>
                    </div>
                    <div className={styles.radioItem}>
                      <RadioItem
                        disabled={false}
                        value={CalculationMethod.Fixed}>
                        {getI18n('storeLogistics.components.fixedrate')}
                      </RadioItem>
                    </div>
                    <div className={styles.radioItem}>
                      <RadioItem
                        disabled={false}
                        value={CalculationMethod.Advanced}>
                        {getI18n('storeLogistics.components.advancedrate')}
                      </RadioItem>
                    </div>
                  </RadioGroup>
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              get(prevValues, 'shippingRate.calculationMethod', '') !==
              get(currentValues, 'shippingRate.calculationMethod', '')
            }>
            {({ getFieldValue }) => {
              return (
                getFieldValue(['shippingRate', 'calculationMethod']) ==
                  CalculationMethod.UseCourier && (
                  <Form.Item
                    label={getI18n(
                      'storeLogistics.components.courierCalculationMethodLabel',
                    )}
                    name={['shippingRate', 'courierCalculationMethod']}
                    initialValue={CourierCalculationMethod.None}
                    rules={[
                      {
                        required: true,
                      },
                    ]}>
                    <RadioGroup>
                      <div className={styles.radioItem}>
                        <RadioItem value={CourierCalculationMethod.None}>
                          {getI18n('general.status.none')}
                        </RadioItem>
                      </div>
                      <div className={styles.radioItem}>
                        <RadioItem
                          disabled={false}
                          value={CourierCalculationMethod.FixAmount}>
                          {getI18n('storeLogistics.components.fixamount')}
                        </RadioItem>
                      </div>
                      <div className={styles.radioItem}>
                        <RadioItem
                          disabled={false}
                          value={CourierCalculationMethod.Percentage}>
                          {getI18n('storeLogistics.components.percentage')}
                        </RadioItem>
                      </div>
                    </RadioGroup>
                  </Form.Item>
                )
              );
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              get(prevValues, 'shippingRate.calculationMethod', '') !==
                get(currentValues, 'shippingRate.calculationMethod', '') ||
              get(prevValues, 'shippingCondition.weightUnit', '') !==
                get(currentValues, 'shippingCondition.weightUnit', '') ||
              get(prevValues, 'shippingCondition.volumeUnit', '') !==
                get(currentValues, 'shippingCondition.volumeUnit', '') ||
              get(prevValues, 'shippingCondition.conditionType', '') !==
                get(currentValues, 'shippingCondition.conditionType', '') ||
              get(prevValues, 'shippingRate.baseLessEqualThan', '') !==
                get(currentValues, 'shippingRate.baseLessEqualThan', '')
            }>
            {({ getFieldValue }) => {
              const conditionType = getFieldValue([
                'shippingCondition',
                'conditionType',
              ]);
              const weightUnit = getFieldValue([
                'shippingCondition',
                'weightUnit',
              ]);
              const volumeUnit = getFieldValue([
                'shippingCondition',
                'volumeUnit',
              ]);
              const unit =
                conditionType === ConditionType.Weight
                  ? weightUnit
                  : volumeUnit;
              return (
                <Fragment>
                  {getFieldValue(['shippingRate', 'calculationMethod']) ==
                    CalculationMethod.Fixed && (
                    <Form.Item
                      name='fixedDeliveryPrices'
                      label={getI18n('storeLogistics.components.deliveryPrice')}
                      initialValue={initCurrencyData}>
                      <RenderTable
                        columns={deliveryPricesColumns('fixedDeliveryPrices', {
                          getI18n,
                        })}
                      />
                    </Form.Item>
                  )}

                  {getFieldValue(['shippingRate', 'calculationMethod']) ==
                    CalculationMethod.Advanced && (
                    <Fragment>
                      <Form.Item
                        className={styles.orderSize}
                        label={
                          getI18n(
                            conditionTypeList[
                              getFieldValue([
                                'shippingCondition',
                                'conditionType',
                              ])
                            ],
                          ) + ' (<=)*'
                        }
                        rules={[
                          {
                            required: true,
                            message: replaceI18nVariables(
                              getI18n('general.fieldisrequired'),
                              getI18n(
                                conditionTypeList[
                                  getFieldValue([
                                    'shippingCondition',
                                    'conditionType',
                                  ])
                                ],
                              ),
                            ),
                          },
                        ]}
                        name={['shippingRate', 'baseLessEqualThan']}>
                        <NumberInput
                          size='large'
                          className={styles.everyGreaterThan}
                          min={0}
                          suffix={unitSuffix[unit]}
                        />
                      </Form.Item>
                      <Form.Item
                        name={'deliveryPrices'}
                        label={getI18n(
                          'storeLogistics.components.deliveryPrice',
                        )}
                        initialValue={initCurrencyData}>
                        <RenderTable
                          columns={deliveryPricesColumns('deliveryPrices', {
                            getI18n,
                          })}
                        />
                      </Form.Item>
                      <Form.Item
                        label={`${replaceI18nVariables(
                          getI18n('storeLogistics.components.over'),
                          getI18n(
                            conditionTypeList[
                              getFieldValue([
                                'shippingCondition',
                                'conditionType',
                              ])
                            ],
                          ),
                          (getFieldValue([
                            'shippingRate',
                            'baseLessEqualThan',
                          ]) || '') +
                            unitSuffix[
                              getFieldValue(['shippingCondition', 'unit'])
                            ],
                        )} *`}
                        className={styles.orderSize}
                        rules={[
                          {
                            required: true,
                            message: replaceI18nVariables(
                              getI18n('general.fieldisrequired'),
                              getI18n(
                                'storeLogistics.components.orderSizeOver',
                              ),
                            ),
                          },
                        ]}
                        name={['shippingRate', 'everyGreaterThan']}>
                        <RenderEveryGreaterThan unit={unit} min={0} />
                      </Form.Item>
                      <Form.Item
                        name={'additionalDeliveryPrices'}
                        label={getI18n(
                          'storeLogistics.components.additionalDeliveryPrice',
                        )}
                        initialValue={initCurrencyData}>
                        <RenderTable
                          columns={additionalDeliveryPriceColumns({ getI18n })}
                        />
                      </Form.Item>
                    </Fragment>
                  )}
                </Fragment>
              );
            }}
          </Form.Item>

          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              get(prevValues, 'shippingRate.calculationMethod', '') !==
                get(currentValues, 'shippingRate.calculationMethod', '') ||
              get(prevValues, 'shippingRate.conditionType', '') !==
                get(currentValues, 'shippingRate.conditionType', '')
            }>
            {({ getFieldValue }) => {
              return (
                <Fragment>
                  {(getFieldValue(['shippingRate', 'calculationMethod']) ==
                    CalculationMethod.UseCourier &&
                    getFieldValue([
                      'shippingRate',
                      'courierCalculationMethod',
                    ])) == CourierCalculationMethod.Percentage && (
                    <Form.Item name={['shippingRate', 'percentageCourierFee']}>
                      <RenderCourierFee />
                    </Form.Item>
                  )}

                  {getFieldValue(['shippingRate', 'calculationMethod']) ==
                    CalculationMethod.UseCourier &&
                    getFieldValue([
                      'shippingRate',
                      'courierCalculationMethod',
                    ]) == CourierCalculationMethod.FixAmount && (
                      <Form.Item
                        name={'FixAmountDeliveryPrices'}
                        initialValue={initCurrencyData}>
                        <RenderTable columns={fixAmountColumns({ getI18n })} />
                      </Form.Item>
                    )}
                </Fragment>
              );
            }}
          </Form.Item>
        </Spin>
      </div>
    </div>
  );
};

export default ShippingRate;
